import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './button/button.component';
import { ModalComponent } from './modal/modal.component';
import { TableComponent } from './table/table.component';

@NgModule({
  declarations: [
    ButtonComponent,
    ModalComponent,
    TableComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ButtonComponent,
    ModalComponent,
    TableComponent
  ]
})
export class UiModule { } 